import React, { useEffect, useState } from "react"
import {
  Alert,
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import { CreatePartRfq } from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"
import { IsPremiumUser } from "helpers/misc_helpers"

// Popup für "Part RFQ": frei beschreibbare Felder. Die Anfrage geht an chipsconnect,
// das intern die Bauteilsuche übernimmt und einen Trader zuweist.
const PartRfqModal = ({ isOpen, toggle, prefill, onSuccess }) => {
  const setLoading = useLoading()
  const [error, setError] = useState("")

  const [partNumber, setPartNumber] = useState("")
  const [manufacturer, setManufacturer] = useState("")
  const [quantity, setQuantity] = useState("")
  const [datecode, setDatecode] = useState("")
  const [comments, setComments] = useState("")

  // Prefill aus dem aktuellen Suchbegriff, wenn das Modal öffnet
  useEffect(() => {
    if (!isOpen) return
    setError("")
    setPartNumber(prefill?.partNumber || "")
    setManufacturer(prefill?.manufacturer || "")
    setQuantity(prefill?.quantity ? String(prefill.quantity) : "")
    setDatecode("")
    setComments("")
  }, [isOpen])

  const handleSubmit = async () => {
    setError("")
    if (!IsPremiumUser()) {
      setError(
        "Part RFQs are a premium feature. Please upgrade your subscription to send RFQs."
      )
      return
    }
    if (!partNumber.trim()) {
      setError("Manufacturer Part Number is required.")
      return
    }
    const qty = parseInt(quantity, 10)
    if (!qty || qty <= 0) {
      setError("Please enter a valid quantity.")
      return
    }

    setLoading(true)
    try {
      await CreatePartRfq({
        partNumber: partNumber.trim(),
        manufacturer: manufacturer.trim() || null,
        quantity: qty,
        datecode: datecode.trim() || null,
        comments: comments.trim() || null,
      })
      toggle()
      if (onSuccess) onSuccess()
    } catch (e) {
      setError(
        e?.response?.data && typeof e.response.data === "string"
          ? e.response.data
          : "Failed to send RFQ. Please try again."
      )
    }
    setLoading(false)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Part RFQ</ModalHeader>
      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}

        {!IsPremiumUser() && (
          <Alert color="warning">
            <i className="bx bx-lock-alt me-1" />
            Part RFQs are a premium feature. Please upgrade your subscription
            to send RFQs.
          </Alert>
        )}

        <Alert color="info">
          <i className="bx bx-info-circle me-1" />
          Your request is sent to chipsconnect — we handle the part search and
          broker the best offer for you.
        </Alert>

        <FormGroup row>
          <Label sm={4}>Manufacturer Part Number *</Label>
          <Col sm={8}>
            <Input
              value={partNumber}
              onChange={e => setPartNumber(e.target.value)}
              placeholder="e.g. STM32F407VGT6"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4}>Manufacturer</Label>
          <Col sm={8}>
            <Input
              value={manufacturer}
              onChange={e => setManufacturer(e.target.value)}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4}>Quantity *</Label>
          <Col sm={8}>
            <Input
              type="number"
              min={1}
              value={quantity}
              onChange={e => setQuantity(e.target.value)}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4}>Datecode</Label>
          <Col sm={8}>
            <Input
              value={datecode}
              onChange={e => setDatecode(e.target.value)}
              placeholder="e.g. 2024+ (optional)"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4}>Comments</Label>
          <Col sm={8}>
            <Input
              type="textarea"
              rows={3}
              value={comments}
              onChange={e => setComments(e.target.value)}
            />
          </Col>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={!IsPremiumUser()}
        >
          <i className="bx bx-send me-1" />
          Send RFQ
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PartRfqModal
